export class DynamoDbBackupConfigApplication {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "readCapacityUnitsRequired",
            "baseName": "readCapacityUnitsRequired",
            "type": "number",
            "format": ""
        },
        {
            "name": "isAutoscaleEnabled",
            "baseName": "isAutoscaleEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "maxReadCapacityUnits",
            "baseName": "maxReadCapacityUnits",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DynamoDbBackupConfigApplication.attributeTypeMap;
    }
    constructor() {
    }
}
